import { useEffect, RefObject, useRef } from 'react';

export const useScrollToOnMount = <T extends HTMLElement>(ref: RefObject<T>, top: boolean = false) => {
    useEffect(
        () => {
            if (ref.current) {
                ref.current.scrollIntoView(top);
            } else {
                console.error('useScrollToOnMount, ref was empty');
            }
        },
        []);
};

export const useScrollToRefOnMount = <T extends HTMLElement>(top: boolean = false) => {
    const ref = useRef<T>(null);
    useScrollToOnMount(ref, top);
    return ref;
};